import {WaterData} from "../types/WaterData";
import {StagingTitelineAppWater} from "../types/StagingTitelineAppWater";
import { getApiUrl } from '../config/api';

export const fetchWaterByPid = async (pid?: number, aid: number = -1): Promise<WaterData[]> => {
    const validPid = pid ?? -1;
    const apiUrl = getApiUrl(`/api/TitelineWater/GetWaterByPid/${validPid}`);

    try {
        const response = await fetch(apiUrl, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            if (response.status === 404) {
                console.warn(`No water found for Pid: ${validPid} (404 Not Found)`);
            } else {
                console.error(`Error fetching water for Pid: ${validPid} - ${response.status} ${response.statusText}`);
            }
            return [];
        }

        let backendData: StagingTitelineAppWater[] = await response.json();
        if (pid === -1) {
            backendData = backendData.filter((water) => water.DataSource === aid.toString());
        }

        return backendData.map((water) => ({
            key: water.Wid,
            wid: water.Wid,
            pid: water.Pid,
            loads: water.Loads,
            kilometres: water.Kilometres,
            litres: water.Litres,
            hours: water.Hours,
            driver: water.Driver,
        }));

    } catch (error) {
        console.error("Error in fetchWaterByPid API call:", error);
        return [];
    }
};

export const addWaterRow = async (waterRow: WaterData, aid: number = -1) => {
    const apiUrl = getApiUrl('/api/TitelineWater/AddWater');

    const cloudPayload = [
        {
            Pid: waterRow.pid,
            Loads: waterRow.loads,
            Kilometres: waterRow.kilometres,
            Litres: waterRow.litres,
            Hours: waterRow.hours,
            Driver: waterRow.driver,
            DataSource: aid,
        },
    ];

    try {
        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(cloudPayload),
        });

        if (response.ok) {
            console.log("Water row added to cloud successfully.");
            return true;
        } else {
            console.error(
                "Failed to add water row to cloud:",
                response.status,
                response.statusText
            );
            return false;
        }
    } catch (error) {
        console.error("Error in addWaterRow API call:", error);
        return false;
    }
};

export const updateWaterRow = async (wid: number, updatedRow: WaterData) => {
    const apiUrl = getApiUrl(`/api/TitelineWater/UpdateWaterByWid/${wid}`);

    const cloudPayload = {
        Loads: updatedRow.loads,
        Kilometres: updatedRow.kilometres,
        Litres: updatedRow.litres,
        Hours: updatedRow.hours,
        Driver: updatedRow.driver,
    };

    try {
        const response = await fetch(apiUrl, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(cloudPayload),
        });

        if (response.ok) {
            console.log(`Water row with Wid ${wid} updated successfully.`);
            return true;
        } else {
            console.error(
                `Failed to update water row with Wid ${wid}:`,
                response.status,
                response.statusText
            );
            return false;
        }
    } catch (error) {
        console.error("Error in updateWaterRow API call:", error);
        return false;
    }
};

export const deleteWaterByWid = async (wid: number) => {
    const apiUrl = getApiUrl(`/api/TitelineWater/DeleteWaterByWid/${wid}`);

    try {
        const response = await fetch(apiUrl, {
            method: "DELETE",
        });

        if (response.ok) {
            const responseData = await response.json();
            console.log("DeleteWaterByWid API response:", responseData);
            return true;
        } else {
            console.error("Failed to delete water row from the cloud:", response.status, response.statusText);
            return false;
        }
    } catch (error) {
        console.error("Error in deleteWaterByWid API call:", error);
        return false;
    }
};